import { HeadCell } from 'models';
import { PARENT_PACKAGE_TYPE } from 'models/parent-package';

export const headCells: readonly HeadCell<PARENT_PACKAGE_TYPE>[] = [
  {
    id: 'parent_first_name',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Parent Name',
  },
  {
    id: 'package_name',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Package Name',
  },
  {
    id: 'balance',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Balance',
  },
  {
    id: 'start_date',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Start Date',
  },
  {
    id: 'expiry_date',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Expiry Date',
  },
];
